import type { Ref, InjectionKey } from 'vue'
import type { AppRoute } from './route-definitions'
import type { GatRouteLocation } from './router-types'

export interface RouterService {
  forceStopNavigation: Ref<boolean>
  unsavedChanges: Ref<boolean>
}

export const routerServiceKey = Symbol('navigation-state') as InjectionKey<RouterService>
